import { format } from "date-fns";


export default function Kanban({projectSteps}) {

  const getStaffName = (task) => task.StaffName || task.Name || task.Staff || "Unassigned";

    const todoTasks = projectSteps.filter((task) => task.kanbanStatus === "todo");
    const inProgressTasks = projectSteps.filter((task) => task.kanbanStatus === "in-progress");
    const completedTasks = projectSteps.filter((task) => task.kanbanStatus === "completed");

    const columns = [
      {
        id: "todo",
        title: "To Do",
        dotColor: "bg-sky-400",
        badgeClass: "bg-sky-100 text-sky-800 border border-sky-200/70",
        cardAccent: "border-sky-400",
        wrapperClass: "bg-white/80 border border-indigo-200/70",
        tasks: todoTasks,
      },
      {
        id: "in-progress",
        title: "In Progress",
        dotColor: "bg-amber-500",
        badgeClass: "bg-amber-100 text-amber-800 border border-amber-200/70",
        cardAccent: "border-amber-500",
        wrapperClass: "bg-white/80 border border-indigo-200/70",
        tasks: inProgressTasks,
      },
      {
        id: "completed",
        title: "Completed",
        dotColor: "bg-emerald-500",
        badgeClass: "bg-emerald-100 text-emerald-800 border border-emerald-200/70",
        cardAccent: "border-emerald-500",
        wrapperClass: "bg-white/80 border border-indigo-200/70",
        tasks: completedTasks,
      },
    ];


    return (
        <section className="mt-6 sm:mt-8">
          <div className="rounded-2xl border border-indigo-200/70 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 p-4 sm:p-6 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.16)]">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-5 sm:mb-6">
              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-indigo-950">Project Tasks</h3>
                <p className="text-xs sm:text-sm text-indigo-600 mt-1">Track task progression from planning through completion.</p>
              </div>
              <div className="inline-flex items-center rounded-full border border-indigo-200/70 bg-white/85 px-3 py-1 text-xs sm:text-sm font-semibold text-indigo-700 shadow-sm w-fit">
                {projectSteps.length} Total Tasks
              </div>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 sm:gap-6">
              {columns.map((column) => (
                <div
                  key={column.id}
                  className={`rounded-2xl ${column.wrapperClass} p-3 sm:p-4 shadow-[0_10px_24px_rgba(99,102,241,0.12)]`}
                >
                  <div className="mb-3 flex items-center justify-between gap-3">
                    <h4 className="font-semibold text-indigo-950 flex items-center text-sm sm:text-base">
                      <span className={`h-2.5 w-2.5 rounded-full ${column.dotColor} mr-2`}></span>
                      {column.title}
                    </h4>
                    <span className="inline-flex items-center rounded-full border border-indigo-200/70 bg-white/85 px-2 py-0.5 text-xs font-semibold text-indigo-700 shadow-sm">
                      {column.tasks.length}
                    </span>
                  </div>

                  <div className="space-y-3 max-h-[26rem] overflow-y-auto pr-1">
                    {column.tasks.length === 0 && (
                      <div className="rounded-xl border border-dashed border-indigo-200/70 bg-white/70 px-3 py-5 text-center text-xs sm:text-sm text-indigo-500">
                        No tasks in this lane.
                      </div>
                    )}

                    {column.tasks.map((task) => (
                      <article
                        key={task.TaskID}
                        className={`rounded-xl border-l-4 ${column.cardAccent} border border-indigo-200/70 bg-white/90 p-3 sm:p-4 shadow-[0_10px_18px_rgba(30,41,59,0.14)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_14px_24px_rgba(30,41,59,0.2)]`}
                      >
                        <p className="font-semibold text-sm sm:text-base text-indigo-950 leading-snug break-words">{task.Task}</p>
                        <p className="text-xs sm:text-sm text-indigo-600 mt-1 break-words line-clamp-3">
                          {task.Description || "No description provided."}
                        </p>

                        <div className="mt-2 inline-flex items-center rounded-lg border border-indigo-200/70 bg-white/85 px-2 py-1 text-xs font-semibold text-indigo-700 shadow-sm">
                          {getStaffName(task)}
                        </div>

                        <div className="mt-3 flex flex-wrap items-center justify-between gap-2">
                          <span className="text-xs text-indigo-700 rounded-lg border border-indigo-200/70 bg-white/85 px-2 py-1">
                            {task.TaskDate ? format(new Date(task.TaskDate), "dd MMM") : "No date"}
                          </span>
                          <span className={`text-xs px-2.5 py-1 rounded-full font-semibold ${column.badgeClass}`}>
                            {task.Role || "Unassigned"}
                          </span>
                        </div>
                      </article>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        );
    }